var map = {
	"./albon.png": 884,
	"./alonso.png": 4104,
	"./bottas.png": 8265,
	"./de_vries.png": 9693,
	"./gasly.png": 2264,
	"./hamilton.png": 3807,
	"./hulkenberg.png": 7929,
	"./kevin_magnussen.png": 3873,
	"./latifi.png": 8348,
	"./leclerc.png": 9259,
	"./max_verstappen.png": 3776,
	"./mick_schumacher.png": 6689,
	"./norris.png": 4650,
	"./ocon.png": 2802,
	"./perez.png": 2840,
	"./ricciardo.png": 4616,
	"./russell.png": 9201,
	"./sainz.png": 9572,
	"./stroll.png": 9282,
	"./tsunoda.png": 8985,
	"./vettel.png": 4464,
	"./zhou.png": 4658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4458;